import React, { useCallback, useEffect, useMemo } from 'react';
import { z } from 'zod'
import { useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import { Col, Input, Row } from 'reactstrap';
import classnames from 'classnames';
import { Form, FormControl } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import Button from '../../../../consulta-acessibilidade/Button';
import { useAccessibilityContext } from '../../../../consulta-acessibilidade/contexts/AccessibilityContext';
import { changeSearch, limparFiltros, changeAcervosFiltrados } from '../../../../../store/ducks/pesquisa';
import { connect, useDispatch } from 'react-redux';
import { useAppContext } from '../../../../../shared/contexts/AppContextProvider';
import { useSearchContext } from '../../../../../shared/contexts/SearchContextProvider';

interface MultimeiosSearchProps {
    loading: boolean;
    error: any;
    guiasPesquisaRx: any
}

const schema = z.object({
    searchTerm: z.string().min(1, 'CampoBuscaObrigatorio'),
    searchOption: z.string().min(1, 'CampoBuscaObrigatorio')
})

type FormData = z.infer<typeof schema>;

const MultimeiosSearch: React.FC<MultimeiosSearchProps> = ({loading, error, guiasPesquisaRx}) => {

    const { t } = useTranslation();
    const { searchInputRef } = useAccessibilityContext()
    const { selectedTab } = useAppContext()
    const dispatch = useDispatch();
    const { search, lastSearchForm } = useSearchContext()

    const {
        handleSubmit,
        reset,
        register,
        formState: {errors}
    } = useForm<FormData>({
        resolver: zodResolver(schema),
        defaultValues: {
            searchOption: '74',
            searchTerm: ''
        }
    })

    const terms = useMemo(() => ([
        { label: t('LIVRE'), value: '74' },
        { label: t('TITULO'), value: '59'},
        { label: t('AUTOR'), value: '65' },
        { label: t('ASSUNTO'), value: '66' },
    ]), [t])


    useEffect(() => {
        if(lastSearchForm){
            reset({
                searchTerm: lastSearchForm.termo_pesquisa,
                searchOption: lastSearchForm.coluna_um,
            })
        }else{
            reset({
                searchTerm: '',
                searchOption: '74',
            })
        }
    }, [lastSearchForm, reset])

    const handleSearch = useCallback(async(data: FormData) => {
        dispatch(limparFiltros());
        dispatch(changeAcervosFiltrados([]));

        let form: any = {
            termo_pesquisa: data.searchTerm,
            coluna_um: data.searchOption,
        }

        let params: any = {
            q: data.searchTerm,
            for: data.searchOption,
        }


        if (guiasPesquisaRx.length) {
            const isPesquisaPaginada = !!guiasPesquisaRx.find(
                (guia: any) =>
                    guia.codigo === selectedTab &&
                    guia.usa_consulta_paginada,
            );
            if (isPesquisaPaginada) {
                const newParams = {
                    page: 1,
                    perPage: 20,
                }
                dispatch(changeSearch(false));
                params = {
                    ...params,
                    ...newParams
                };
                form = {
                    ...form,
                    ...newParams
                };
            }
        }

        await search(form, params);
    }, [selectedTab])

    return (
        <Form onSubmit={handleSubmit(handleSearch)}
              className="content__left__input p-3">
            <Col lg="8" md="7" sm="12" className="input-holder mt-3">
                <div className='rotulo'>
                    {t('CampoBusca')}
                </div>
                <FormControl
                    {...register('searchTerm')}
                    ref={(e: any) => {
                        register('searchTerm').ref(e);
                        searchInputRef.current = e;
                    }}
                    type="search"
                    className="rad10 b-tema20 cortxt foco"
                    placeholder={t('DigiteSuaBuscaAqui')}
                    isInvalid={errors.searchTerm !== undefined}
                />
                {errors.searchTerm ? (
                    <FormControl.Feedback type="invalid">
                        {t(errors.searchTerm?.message as any)}
                    </FormControl.Feedback>
                ) : (
                    ''
                )}
            </Col>
            <Col lg="2" md="3" sm="12" className="input-holder mt-3">
                <   div className='rotulo'>
                    {t('TipoPesquisas')}
                </div>
                <FormControl
                    as="select"
                    className="b-tema20 cortxt rad10 s14"
                    {...register('searchOption')}
                >
                    {terms.map(term => (
                        <option
                            key={`termo-${term.value}`}
                            value={term.value}
                        >
                            {term.label}
                        </option>
                    ))}
                </FormControl>
            </Col>
            <Col
                md="2"
                lg="2"
                sm="12"
                className={classnames(' mt-3 align-self-end pb-0', { 'mb-4': error })}
            >
                <Button
                    title="Pesquisar"
                    icon="search"
                    variant='primeiro ml-0 btn-responsivo'
                    type="submit"
                    disabled={loading}
                />
            </Col>
        </Form>
    )
}

const mapStateToProps = (state: any) => ({
    guiasPesquisaRx: state.pageConfig.guiasPesquisa,
});
export default connect(mapStateToProps)(MultimeiosSearch);
